import React, { memo, PropsWithChildren } from 'react';
import './root.scss';
import useLoginWithOkta from './features/login/hooks/useLoginWithOkta';

const ForAuthenticated = ({ children }: PropsWithChildren<{}>) => {
  useLoginWithOkta();
  return <>{children}</>;
};

export default memo(ForAuthenticated);
